import { render, staticRenderFns } from "./detail-drawer.vue?vue&type=template&id=2d655272&"
import script from "./detail-drawer.vue?vue&type=script&lang=js&"
export * from "./detail-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports